module.exports = __webpack_public_path__ + "static/img/dlogo.1e34836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dlogo.png
// module id = LwjX
// module chunks = 18